module.exports = __webpack_public_path__ + "static/media/AHTT_logo.272138ed.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AHTT_logo.gif
// module id = 65
// module chunks = 0